/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import*as e from"react";var t=e.forwardRef((function({title:t,titleId:l,...a},r){return e.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20",fill:"currentColor","aria-hidden":"true",ref:r,"aria-labelledby":l},a),t?e.createElement("title",{id:l},t):null,e.createElement("path",{fillRule:"evenodd",d:"M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",clipRule:"evenodd"}))}));export{t as default};
//# sourceMappingURL=ChevronRightIcon.js.map
